<div class="col-12" style="padding: 0 10px;">
  <div class="d-flex justify-content-between">
  <div class="d-flex justify-content-between align-items-center header-container">
    <h1 class="chart-head" style="margin-top: 10px;">Follow Up Count</h1>
  </div>
  <div class="d-flex justify-content-between align-items-center header-container">
    <div class="comparison d-flex align-items-center ms-auto">

      <div class="stats mr-3" *ngIf="selectedFollowupCardIndex != 0">
        <span class="stat-title mr-1">Total Enquiries</span>
        <span class="stat-value">{{totalEnquiries}}</span>
      </div>

      <div class="stats mr-3" *ngIf="selectedFollowupCardIndex != 0">
        <span class="stat-title mr-1">Zero follow up</span>
        <span class="stat-value">{{zeroFollowup}}</span>
      </div>

    </div>
  </div>
  </div>

  <div class="d-flex align-items-center header-container stats-row" *ngIf="selectedFollowupCardIndex == 0">
    <div class="stats">
      <span class="stat-title mr-1">Total Leads</span>
      <span class="stat-value">{{stageCounts.totalLeads}}</span>
    </div>
    <div class="stats">
      <span class="stat-title mr-1">Untouched</span>
      <span class="stat-value">{{stageCounts.untouchedLeads}}</span>
    </div>
    <div class="stats" style="background-color: #1890FF;">
      <span class="stat-title mr-1" style="color: white;">Follow-up & No-response</span>
      <span class="stat-value">{{stageCounts.noResponse}}</span>
    </div>
    <div class="stats">
      <span class="stat-title mr-1">Disposed (Junk/Drop)</span>
      <span class="stat-value">{{stageCounts.junk}}</span>
    </div>
    <div class="stats">
      <span class="stat-title mr-1">Disposed (Non-Sales)</span>
      <span class="stat-value">{{stageCounts.nonSales}}</span>
    </div>
    <div class="stats">
      <span class="stat-title mr-1">Disposed (Assigned to DSE)</span>
      <span class="stat-value">{{stageCounts.assigned}}</span>
    </div>
  </div>

  <div class="row">
    <ng-container *ngIf="hasChartData()">
      <apx-chart [series]="horizontalBarOptions.series" [chart]="horizontalBarOptions.chart"
        [dataLabels]="horizontalBarOptions.dataLabels" [plotOptions]="horizontalBarOptions.plotOptions"
        [xaxis]="horizontalBarOptions.xaxis" [stroke]="horizontalBarOptions.stroke" [legend]="{show: false}">

      </apx-chart>
    </ng-container>
    <ng-container *ngIf="!hasChartData()">
      <div class="no-data-available">
        <img [src]="bucketUrl + '/images/no-data-available.png'" alt="">
      </div>
    </ng-container>

  </div>
</div>